export default __webpack_public_path__ + "static/media/linkedin-logo.4ceb55b0.svg";